export class CalcState {
    insuranceProviderId: string = null // provider.code //todo rename is ic.name - "alfa" or other
    amount?: number = null
    status: CalcStatus = CalcStatus.NeedToCalc
    beginDate?: Date = null
    month?: number = null
    isSuccess: boolean = false;
    crossAmount?: number = null
    payLink?: string; // should not exist on fastCalc
    expirationDate?: Date; // should not exist on fastCalc
}

// unused statuses commented out
export enum CalcStatus {
    NeedToCalc = 1,
    Processing = 2,
    // CheckQuote = 3,
    CalcSuccess = 4,
    CalcFail = 5,
    NeedToSelectCar = 6,
    // WaitForSmsConfirm = 7,
    TryToIssue = 8,
    IssueRejected = 9, // not used anymore?
    Issued = 10,
    // NeedToUploadDocs,//c cat загрузка документов
    // DocUploadError,//c cat после получения ответа с ошибкой
    PreScoringSuccess = 13//c cat прерасчёт
}

export class CalcCofInfo {
    tb: string = "";
    kt: string = "";
    kbm: string = "";
    kbc: string = "";
    ko: string = "";
    ks: string = "";
    km: string = "";
    kn: string = "";
}
export class CarDocumentInput {
    seria: string = "";
    number: string = "";
}

export enum CarSerialType {
    vin = 1,
    body,
    chassis
}

export enum CarDocumentType {
    STS = 31,
    PTS = 30,
    EPTS = 41
}
